import { render, staticRenderFns } from "./CourseSelection.vue?vue&type=template&id=d0012978&scoped=true"
import script from "./CourseSelection.vue?vue&type=script&lang=js"
export * from "./CourseSelection.vue?vue&type=script&lang=js"
import style0 from "./CourseSelection.vue?vue&type=style&index=0&id=d0012978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0012978",
  null
  
)

export default component.exports